import { useState, useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { enqueueErrorSnackbar } from '../../../actions/Notifications';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

export const useWizardStepData = (currentStepIndex) => {
  const t = useLocalizedMessage();
  const dispatch = useDispatch();
  const [stepData, setStepData] = useState({});
  const [readyMap, setReadyMap] = useState({});
  const stepSaveRef = useRef(null);

  useEffect(() => {
    setStepData({});
  }, [currentStepIndex]);

  const handleStepUpdate = useCallback((newData) => {
    setStepData((prev) => ({ ...prev, ...newData }));
  }, []);

  const handleStepReady = useCallback(
    (isReady) => {
      setReadyMap((prev) => ({
        ...prev,
        [currentStepIndex]: isReady,
      }));
    },
    [currentStepIndex],
  );

  const handleRegisterSave = useCallback((saveFn) => {
    stepSaveRef.current = saveFn;
  }, []);

  const executeSave = useCallback(async () => {
    if (stepSaveRef.current) {
      try {
        await stepSaveRef.current();
      } catch (e) {
        dispatch(enqueueErrorSnackbar(e.message || t('wizard.step.saveFailed')));
        throw e;
      }
    }
  }, [dispatch, t]);

  const hasStepData = Object.keys(stepData).length > 0;
  const isStepReady = readyMap[currentStepIndex] !== false;

  return {
    stepData,
    hasStepData,
    isStepReady,
    handleStepUpdate,
    handleStepReady,
    handleRegisterSave,
    executeSave,
  };
};
